"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moneyBack = exports.listProfitFromAffiliation = exports.listAffiliations = void 0;
const createApi_1 = require("../../helpers/createApi");
const listAffiliations = (caller) => ({ accountId }) => {
    return caller(`/affiliations?account_ids=${accountId}`).get();
};
exports.listAffiliations = listAffiliations;
const listProfitFromAffiliation = (caller) => ({ accountId, affiliation }) => {
    return caller(`/profits?account_ids=${accountId}&affiliation=${affiliation}`).get();
};
exports.listProfitFromAffiliation = listProfitFromAffiliation;
exports.moneyBack = (0, createApi_1.createAPIFactory)({
    listAffiliations: exports.listAffiliations,
    listProfitFromAffiliation: exports.listProfitFromAffiliation,
});
//# sourceMappingURL=api.js.map